import { format as formatDate } from 'date-fns';
export function resolveSlotText(slotType, d) {
    if (d.override)
        return d.override;
    // A certificate date is a CALENDAR date held at UTC midnight, and date-fns formats in
    // the server's local timezone. Shifting by the offset makes the local-time formatter
    // print the UTC day, so the certificate reads the date the operator chose wherever it
    // is deployed. See `formatAuCalendarDate` in packages/shared.
    const onPaper = new Date(d.certificateDate.getTime() + d.certificateDate.getTimezoneOffset() * 60_000);
    switch (slotType) {
        case 'CERTIFICATE_NUMBER':
            return d.certificateNo;
        case 'DATE':
            return formatDate(onPaper, toDateFnsFormat(d.dateFormat));
        case 'DESIGNATION':
            return d.designation;
        case 'SIGNATORY_NAME':
            return d.signatoryName;
        case 'ISSUED_AT':
            return d.issuedAtText;
        case 'ISSUED_AT_LINE':
            // The form line that reads "BRISBANE, 18/09/2026" on the real IA-CEPA sample.
            return `${d.issuedAtText}, ${formatDate(onPaper, toDateFnsFormat(d.dateFormat))}`;
        case 'FREE_TEXT':
            return d.staticText;
        default:
            return d.staticText;
    }
}
/**
 * Administrators configure dates the way they appear on the form (`DD/MM/YYYY`), which
 * is not date-fns' token language (`dd/MM/yyyy`). Translating here means the
 * configuration screen can speak the language its users already read on the certificate.
 */
export function toDateFnsFormat(pattern) {
    return pattern
        .replace(/DD/g, 'dd')
        .replace(/YYYY/g, 'yyyy')
        .replace(/YY(?!YY)/g, 'yy')
        .replace(/MMMM/g, 'MMMM')
        .replace(/D(?!d)/g, 'd');
}
/**
 * The stand-in values the configuration screens render with, in the canvas and in the
 * server-side proof alike. Deliberately obvious as samples: a proof is watermarked
 * PREVIEW and must never read as a real certificate.
 */
export const SAMPLE_CERTIFICATE_NO = 'SAMPLE-000001';
export const SAMPLE_SIGNATORY_NAME = 'A. Sample';
export const SAMPLE_DESIGNATION = 'Authorised Signatory';
/** Shown for a fixed-text mark the administrator has not typed anything into yet. */
export const SAMPLE_FREE_TEXT = 'Sample text';
//# sourceMappingURL=slot-text.js.map